/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Partner_Customer_Kpi_ContractedInputs */



/**
* | output |
* | --- |
* | "{seats} contracted seats" |
*
* @param {Partner_Customer_Kpi_ContractedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_kpi_contracted = /** @type {((inputs: Partner_Customer_Kpi_ContractedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Kpi_ContractedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} vereinbarte Plätze`)
	return /** @type {LocalizedString} */ (`${i?.seats} contracted seats`)
});